import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';

const embbeddingContext = createEmbeddingContext();
export const getEmbeddingContext = () => embbeddingContext;
